import { gtm } from "@pod-point/tracking.js";

const init = (gtmId) => {
    gtm.init(gtmId);
};

const trackEvent = (event, properties = {}) => {
    gtm.track(event, properties);
};

export { trackEvent, init };
